<template>
  <div :class="[size,{touch:touch},typeClass,{border},{disabled:disabled}]" class="v-common-btn tac"
       @touchstart="touchstart"
       @click="handler" @touchend="touchend">
    <slot></slot>
  </div>
</template>

<script>
/**
 *
 * @property size string [big|normal|small|mini]
 */
const typeMap = ['primary', 'default', 'error', 'plain', 'warn'];
export default {
  name: "v-common-btn",
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    //节流控制
    throttle: {
      type: Number,
      default: 1000
    },
    //按钮样式 primary
    type: {
      type: String,
      default: typeMap[0]
    },
    border: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      time: 0,
      touch: false
    }
  },
  computed: {
    typeClass() {
      const {type, disabled} = this;
      if (type === typeMap[0])
        return 'color_fff bg_main'
      if (type === typeMap[1])
        return 'bg color_666'
      if (type === typeMap[2])
        return 'bg_red color_fff'
      if (type === typeMap[3])
        return 'color_333'
      if (type === typeMap[4])
        return 'color_fff bg_warn'
    }

  },
  methods: {
    handler(e) {
      if (this.disabled) return this.$emit('error', e);
      const now = Date.now();
      if (now - this.time > this.throttle) {
        this.time = now;
        this.$emit('click', e);
      } else {
        bus.$emit('msg', `操作太频繁了,请${parseInt((this.throttle - now + this.time) / 1000)}s后再试`);
      }
    },
    touchstart() {
      this.touch = true;
    },
    touchend() {
      this.touch = false;
    }
  },
}
</script>

<style scoped lang="scss">
@import "../common/public";

.v-common-btn {
  @include h_lh(45px);

  &.small {
    @include h_lh(30px);
  }

  &.mini {
    @include h_lh(24px);
  }

  &.touch {
    background-color: rgba($mainColor, 0.9);
  }

  &.border {
    border: 0.5px solid #333333;
  }

  &.disabled {
    filter: alpha(0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/v-common-btn.vue